import { CMSResource } from "app/resources/cmsresource";
import { KioskResource } from './KioskResource';

export class KioskListResource extends CMSResource {
    public list: KioskResource[];
}